export const questionnairesEn = {
  nav: {
    field: 'Field service',
    cockpit: 'Field-service cockpit',
    runs: 'Runs',
    templates: 'Questionnaires',
    results: 'Questionnaire results',
  },
  permissions: { denied: 'You do not have the required questionnaire permission.' },
  statuses: {
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
    ARCHIVED: 'Archived',
    IN_PROGRESS: 'In progress',
    PAUSED: 'Paused',
    COMPLETED: 'Completed',
    ABANDONED: 'Abandoned',
    SYNC_PENDING: 'Sync pending',
    SYNC_FAILED: 'Sync failed',
  },
  sync: {
    online: 'Online',
    offline: 'Offline',
    syncing: 'Synchronising',
    pending: 'Pending',
    failed: 'Error',
    synced: 'Synced',
    retry: 'Retry synchronisation',
    conflict: 'The server has a newer version. Review the conflict.',
  },
  questionTypes: {
    SHORT_TEXT: 'Short text',
    LONG_TEXT: 'Long text',
    NUMBER: 'Number',
    DECIMAL: 'Decimal',
    CURRENCY: 'Currency',
    PERCENTAGE: 'Percentage',
    PERCENT: 'Percentage',
    DATE: 'Date',
    TIME: 'Time',
    DATE_TIME: 'Date and time',
    DATETIME: 'Date and time',
    YES_NO: 'Yes / No',
    CHECKBOX: 'Checkbox',
    SINGLE_CHOICE: 'Single choice',
    RADIO: 'Single choice',
    MULTIPLE_CHOICE: 'Multiple choice',
    MULTI_CHOICE: 'Multiple choice',
    DROPDOWN: 'Dropdown',
    COMBOBOX: 'Searchable choice',
    RATING_SCALE: 'Rating scale',
    STAR_RATING: 'Star rating',
    SLIDER: 'Slider',
    EMAIL: 'Email address',
    PHONE: 'Phone number',
    URL: 'Web address',
    ADDRESS: 'Address',
    HEADING: 'Heading',
    INFORMATION: 'Information',
    INFO_TEXT: 'Information',
    DIVIDER: 'Divider',
    FILE_UPLOAD: 'File upload',
    PHOTO: 'Photo',
    IMAGE_GALLERY: 'Image gallery',
    SIGNATURE: 'Signature',
    CONSENT: 'Consent / privacy',
    PRODUCT_SINGLE: 'Product selection',
    PRODUCT_MULTIPLE: 'Multiple products',
    PRODUCT_MULTI: 'Multiple products',
    PRODUCT_CATALOG: 'Product catalogue',
    PRODUCT_QUANTITY_LIST: 'Product quantity list',
    REPEATABLE_GROUP: 'Repeatable group',
  },
  scopes: {
    EXISTING_CUSTOMER: 'Existing customer',
    NEW_CUSTOMER: 'New customer',
    PROSPECT: 'Prospect',
    SUPPLIER: 'Supplier',
    PARTNER: 'Business partner',
    PARTNERLESS: 'Without partner',
    OTHER: 'Other purpose',
  },
  cockpit: {
    title: 'Field-service cockpit',
    subtitle: 'Start, continue and securely review questionnaires.',
    newRun: 'New questionnaire',
    partnerless: 'Questionnaire without partner',
    today: "Today's runs",
    drafts: 'Drafts',
    paused: 'Paused questionnaires',
    unsynced: 'Not synchronised',
    followUp: 'Review required',
    recentTemplates: 'Recently used templates',
    recentPartners: 'Recently used partners',
    search: 'Search runs',
    searchPlaceholder: 'Template, partner or contact',
    allStatuses: 'All statuses',
    allTemplates: 'All templates',
    empty: 'No questionnaire runs yet.',
    emptyHint: 'Start the first questionnaire from the field-service cockpit.',
    loadError: 'The field-service cockpit could not be loaded.',
    summaryLoadError: 'The cockpit metrics could not be loaded.',
    continue: 'Continue',
    review: 'Review',
    progress: '{{value}}%',
  },
  start: {
    title: 'New questionnaire',
    subtitle: 'Select a partner, contact and published template.',
    context: 'Context',
    withPartner: 'With business partner',
    withoutPartner: 'Without an existing partner',
    partner: 'Business partner',
    partnerSearch: 'Search partners',
    partnerSearchPlaceholder: 'Company, name, email or partner number',
    contact: 'Contact',
    noContact: 'No contact',
    template: 'Template',
    matchingTemplates: 'Matching templates',
    extendedTemplates: 'Other published templates',
    showExtended: 'Show extended selection',
    noTemplates: 'No published template is available for this context.',
    create: 'Create questionnaire',
    creating: 'Creating questionnaire',
    created: 'The questionnaire was created.',
    createError: 'The questionnaire could not be created.',
    partnerlessData: 'Optional contact details',
    company: 'Company',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    source: 'Source',
    note: 'Note',
    contactConsent: 'Consent to be contacted has been given',
    sourcePlaceholder: 'e.g. trade fair or field visit',
    noPartnerRequired: 'All contact details may remain empty unless required by the template.',
    fromPartner: 'Start questionnaire',
    fromContact: 'Start questionnaire for contact',
  },
  run: {
    loading: 'Loading questionnaire.',
    loadError: 'The questionnaire could not be loaded.',
    notFound: 'The questionnaire was not found or cannot be opened.',
    answers: 'Answers',
    files: 'Files and photos',
    products: 'Products',
    internal: 'Employees only',
    required: 'Required field',
    notApplicable: 'Not applicable',
    hidden: 'Hidden by rule',
    saveState: 'Save status',
    saved: 'All changes saved.',
    saving: 'Saving changes.',
    saveFailed: 'Changes could not be saved.',
    localSaved: 'Draft encrypted on this device.',
    start: 'Start questionnaire',
    pause: 'Pause',
    resume: 'Resume',
    abandon: 'Abandon',
    complete: 'Complete questionnaire',
    completeTitle: 'Complete questionnaire?',
    completeDescription: 'Answers will be validated on the server and then locked.',
    completeSuccess: 'The questionnaire was completed.',
    completeError: 'The questionnaire could not be completed.',
    pauseSuccess: 'The questionnaire was paused.',
    abandonTitle: 'Abandon questionnaire?',
    abandonDescription: 'The abandonment remains recorded in the audit trail.',
    abandonSuccess: 'The questionnaire was abandoned.',
    customerMode: 'Start customer mode',
    customerModeHint: 'Check the partner and template before handing over the device.',
    handoverTitle: 'Hand device to customer',
    handoverDescription: 'Customer mode hides the ERP interface and shows only approved questions.',
    handoverConfirm: 'Activate customer mode',
    revision: 'Create correction revision',
    sectionProgress: 'Section {{current}} of {{total}}',
    questionProgress: 'Question {{current}} of {{total}}',
    validationError: 'Please review the highlighted required fields.',
  },
  renderer: {
    yes: 'Yes',
    no: 'No',
    choose: 'Please select',
    search: 'Search options',
    noOptions: 'No matching options',
    selectedCount: '{{count}} selected',
    addGroup: 'Add another entry',
    removeGroup: 'Remove entry',
    groupLabel: 'Entry {{index}}',
    repeatMissing: 'The configured child question is unavailable.',
    repeatUnsupported: '“{{label}}” cannot be stored securely inside a repeatable group.',
    addressStreet: 'Street',
    addressHouseNumber: 'House number',
    addressPostalCode: 'Postal code',
    addressCity: 'City',
    addressCountry: 'Country',
    clear: 'Clear input',
    stars: '{{count}} of {{max}} stars',
    signatureHint: 'Please sign inside the field.',
    signerName: 'Name of the signing person',
    signatureChooseImage: 'Choose PNG signature',
    signatureClear: 'Clear signature',
    signatureDisclaimer: 'The drawn signature is not a qualified electronic signature.',
    consentName: 'Name of confirming person',
    consentConfirmed: 'I confirm the displayed consent.',
    consentVersion: 'Document version {{version}}',
  },
  media: {
    addFile: 'Choose file',
    takePhoto: 'Take photo',
    takeRearPhoto: 'Use rear camera',
    takeFrontPhoto: 'Use front camera',
    chooseGallery: 'Choose from gallery',
    preview: 'Preview',
    previewReady: 'Preview – not accepted yet',
    accept: 'Accept photo or file',
    retake: 'Retake',
    rotate: 'Rotate',
    remove: 'Remove file',
    description: 'Description',
    queued: 'Queued for upload',
    uploading: 'Upload {{progress}}%',
    uploaded: 'Securely uploaded',
    uploadFailed: 'Upload failed',
    deleteFailed: 'The file could not be deleted securely.',
    retryUpload: 'Retry upload',
    cameraUnavailable: 'The camera is not available in this browser.',
    permissionDenied: 'Camera access was not allowed. Check the browser permission.',
    invalidFile: 'The file does not meet the permitted format or size.',
    metadataHint: 'Image metadata is removed on the server before permanent storage.',
    empty: 'No file selected.',
  },
  products: {
    search: 'Search products',
    searchPlaceholder: 'Product name or number',
    empty: 'No matching products found.',
    unknown: 'No longer in the current catalogue',
    loadError: 'Products could not be loaded.',
    selected: 'Selected',
    selectedProduct: 'Selected product',
    select: 'Select product',
    remove: 'Remove product',
    articleNumber: 'Product number',
    quantity: 'Requested quantity',
    packaging: 'Packaging unit',
    packagingLabel: '{{name}} ({{code}})',
    interest: 'Interest',
    currentProduct: 'Current competing product',
    currentUse: 'Product is currently in use',
    comparisonGroup: 'Product comparison / comparison group',
    plannedPurchaseDate: 'Planned purchase date',
    note: 'Comment',
    photo: 'Product photo',
    photoFileName: 'Product photo',
    wishlist: 'Add to wishlist',
    priceRestricted: 'Prices are not shown in this customer view.',
    available: 'Available',
    unavailable: 'Currently unavailable',
    interestLevels: { NONE: 'No interest', LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High' },
  },
  customer: {
    completedBrand: 'Questionnaire',
    loading: 'Opening questionnaire securely.',
    unavailableTitle: 'Questionnaire unavailable',
    unavailable:
      'The customer-mode session has expired or ended. Please return the device to the employee.',
    fullscreen: 'Open full screen',
    fullscreenExit: 'Exit full screen',
    fullscreenFailed: 'The browser could not activate full screen mode.',
    welcomeHeading: 'Welcome',
    privacyNoticeHeading: 'Privacy notice',
    titleImageAlt: 'Title image for {{title}}',
    privacyTitle: 'Content is concealed',
    privacyDescription: 'The view was locked because of inactivity or a tab change.',
    privacyAction: 'Hand to employee',
    inactive: 'The view was locked because of inactivity.',
    tabHidden: 'The content remains concealed after changing tabs.',
    previous: 'Back',
    next: 'Next',
    finish: 'Submit answers',
    thankYouTitle: 'Thank you',
    thankYou: 'Your answers were submitted securely. Please return the device to the employee.',
    noErpAccess: 'This view does not provide access to the ERP.',
    unlockTitle: 'Employee unlock',
    unlockDescription: 'Returning to internal review requires renewed employee verification.',
    password: 'Current employee password',
    unlock: 'Unlock review',
    unlockFailed: 'Employee verification failed.',
    unlockSuccess: 'Internal review has been unlocked.',
    cleanupFailed:
      'The local questionnaire data could not yet be removed securely. Please try again.',
    cleanupRetry: 'Remove local data again',
    securityLimit:
      'Customer mode is a privacy screen within the web application. It cannot fully control operating-system functions, screenshots or other browser tabs.',
  },
  offline: {
    supported: 'Secure offline use available',
    unavailable: 'Secure offline use is not available in this browser.',
    unavailableSensitive:
      'This sensitive template cannot be used offline without secure encryption.',
    encryption: 'Local drafts and media are encrypted with Web Crypto and stored in IndexedDB.',
    preparing: 'Preparing offline data.',
    prepared: 'Template is available offline.',
    packageCount: '{{count}} offline template(s) securely preloaded.',
    preloadFailed: 'Offline templates could not be refreshed.',
    partnerContextRequired:
      'Partner-related questionnaires can only be started offline with securely preloaded partner context.',
    localRunCreated: 'The questionnaire was created securely offline.',
    customerPageUnavailable:
      'This page has not been securely preloaded yet. Reconnect to continue.',
    customerCompletionPending:
      'The answers are encrypted on this device and will be completed after reconnecting.',
    localRunSyncing: 'The offline questionnaire is being synchronised with the server.',
    localRunConflict:
      'The server state has changed. Local data remains encrypted and available for recovery.',
    cleanup: 'Local data was removed after successful synchronisation.',
  },
  postprocess: {
    title: 'Review',
    subtitle: 'Review results and deliberately apply ERP actions.',
    completeness: 'Completeness check',
    complete: 'Complete',
    incomplete: 'Incomplete',
    partnerAssignment: 'Partner assignment',
    currentPartner: 'Assigned partner',
    partnerless: 'Not assigned to a partner yet',
    searchPartner: 'Search existing partner',
    linkPartner: 'Link partner',
    linked: 'The business partner was linked.',
    linkError: 'The business partner could not be linked.',
    createProspect: 'Create prospect',
    createCustomer: 'Create customer',
    duplicates: 'Possible duplicates',
    duplicateCheck: 'Duplicate check before creation',
    noDuplicates: 'No possible duplicates found.',
    duplicatesAcknowledged: 'I reviewed the possible duplicates and confirm creating this record.',
    conversionConfirmation:
      'Review the master data preview. The existing partner logic creates and links the record only after your confirmation.',
    confirmConversion: 'Confirm creation and link',
    converted: '{{name}} was created and linked to the questionnaire.',
    conversionError:
      'The record could not be created. Review required fields and possible duplicates.',
    proposedActions: 'Suggested ERP actions',
    preview: 'Transfer preview',
    confirm: 'Run selected action',
    confirmationRequired: 'The action runs only after your explicit confirmation.',
    noSilentChanges: 'No master data is changed silently.',
    actionSuccess: 'The ERP action was completed.',
    actionError: 'The ERP action could not be completed.',
    dueAt: 'Due at',
    assignmentRequired: 'A business partner must be assigned before running this action.',
    contactData: 'New contact details',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email address',
    phone: 'Phone number',
    leadStatus: 'New pipeline stage',
    leadStatuses: {
      NEW: 'New',
      CONTACTED: 'Contacted',
      QUALIFIED: 'Qualified',
      PROPOSAL_SENT: 'Proposal sent',
      NEGOTIATION: 'Negotiation',
      WON: 'Won',
      LOST: 'Lost',
    },
    actions: {
      CREATE_QUOTE_DRAFT: 'Create quote draft',
      CREATE_ORDER_DRAFT: 'Create order draft',
      CREATE_PROSPECT_NEED: 'Record prospect need',
      CREATE_PARTNER_NOTE: 'Create partner note',
      CREATE_FOLLOW_UP: 'Create follow-up',
      CREATE_TASK: 'Create task',
      ADD_CONTACT: 'Add contact',
      UPDATE_PROSPECT_PIPELINE: 'Update prospect pipeline',
      EXPOSE_DMS_FILES: 'Show files in partner record',
      SAVE_PRODUCT_INTEREST: 'Save product interest',
      ADD_PRODUCT_WATCHLIST: 'Add products to watchlist',
    },
  },
  templates: {
    title: 'Questionnaire templates',
    subtitle: 'Create, validate and publish versioned templates.',
    create: 'New template',
    createTitle: 'Create template',
    internalName: 'Internal name',
    visibleTitle: 'Visible title',
    description: 'Description',
    language: 'Language',
    applications: 'Application scopes',
    version: 'Version {{version}}',
    updatedAt: 'Updated {{date}}',
    empty: 'No questionnaire template yet.',
    loadError: 'Templates could not be loaded.',
    created: 'The template was created.',
    duplicate: 'Duplicate template',
    archive: 'Archive template',
    archived: 'The template was archived.',
    edit: 'Open builder',
  },
  builder: {
    title: 'Form builder',
    back: 'Back to templates',
    palette: 'Components',
    workspace: 'Form',
    properties: 'Properties',
    templateProperties: 'Template',
    sections: 'Sections',
    addSection: 'Add section',
    sectionTitle: 'Section heading',
    sectionDescription: 'Section description',
    untitledSection: 'Untitled section',
    untitledQuestion: 'Untitled question',
    selectHint: 'Select a question or section.',
    dragHint: 'Drag or use the keyboard to insert into the form.',
    keyboardHint: 'Space to pick up, arrow keys to move, space to drop.',
    save: 'Save draft',
    saved: 'The template draft was saved.',
    saveError: 'The template draft could not be saved.',
    unsaved: 'Unsaved changes',
    discardTitle: 'Discard unsaved changes?',
    discardDescription:
      'Switching versions discards changes to this version that have not been saved yet.',
    discardChanges: 'Discard changes',
    validate: 'Validate',
    valid: 'The template is ready to publish.',
    invalid: 'The template still contains business errors.',
    publish: 'Publish',
    publishTitle: 'Publish template version?',
    publishDescription: 'The published version will be frozen and immutable.',
    published: 'The template version was published.',
    publishError: 'The template version could not be published.',
    preview: 'Preview',
    previewHint: 'Review presentation and logic at the supported device widths.',
    previewDevice: 'Preview device',
    devices: { phone: 'Phone', tablet: 'Tablet', desktop: 'Desktop' },
    addQuestion: 'Add question',
    createDraft: 'Create new draft version',
    deleteSection: 'Remove section',
    repeatChild: 'Child question',
    copySuffix: '(copy)',
    duplicateQuestion: 'Duplicate question',
    deleteQuestion: 'Remove question',
    moveUp: 'Move up',
    moveDown: 'Move down',
    internalKey: 'Stable internal key',
    label: 'Label',
    helpText: 'Help text',
    placeholder: 'Placeholder',
    prefillPartnerField: 'Prefill from business partner field',
    erpTargetField: 'Later ERP field mapping',
    analyticsKey: 'Analytics key',
    required: 'Required',
    internal: 'Internal only',
    customerVisible: 'Visible in customer mode',
    searchable: 'Enabled for analytics',
    sensitive: 'Sensitive data',
    sensitivity: {
      NONE: 'No sensitive classification',
      PERSONAL: 'Personal data',
      SPECIAL_CATEGORY: 'Special category of personal data',
      CONFIDENTIAL_BUSINESS: 'Confidential business data',
    },
    minLength: 'Minimum length',
    maxLength: 'Maximum length',
    minValue: 'Minimum value',
    maxValue: 'Maximum value',
    decimals: 'Decimal places',
    step: 'Step',
    address: {
      requireStreet: 'Require street',
      requirePostalCode: 'Require postal code',
      requireCity: 'Require city',
      requireCountry: 'Require country',
    },
    pattern: 'Safe regular expression',
    validationMessage: 'Validation message',
    defaultValue: 'Default value',
    noDefault: 'No default value',
    clearDefault: 'Clear default value',
    options: 'Choice options',
    optionValue: 'Stable value',
    optionLabel: 'Label',
    optionDescription: 'Description',
    translations: 'Translations',
    primaryLanguage: 'Primary language',
    locales: {
      tr: 'Turkish',
      fr: 'French',
      es: 'Spanish',
      de: 'German',
      en: 'English',
    },
    titleImage: 'Optional title image from DMS',
    titleImageUpload: 'Upload title image',
    titleImageRemove: 'Remove title image',
    titleImageEmpty: 'No images are available in DMS yet.',
    titleImageError: 'The DMS images could not be loaded or uploaded.',
    titleImageDmsPermission: 'DMS read permission is required to select a title image.',
    removeChip: 'Remove {{value}}',
    addOption: 'Add option',
    moveOptionUp: 'Move option up',
    moveOptionDown: 'Move option down',
    allowedFileFormats: 'Allowed file formats',
    fileFormats: {
      PDF: 'PDF',
      JPEG: 'JPEG',
      PNG: 'PNG',
      WEBP: 'WebP',
      DOCX: 'Word (DOCX)',
      XLSX: 'Excel (XLSX)',
      TXT: 'Text file (TXT)',
      CSV: 'CSV',
    },
    newOption: 'Option {{index}}',
    removeOption: 'Remove option',
    randomizeOptions: 'Randomise options',
    minSelections: 'Minimum selections',
    maxSelections: 'Maximum selections',
    maxFiles: 'Maximum number of files',
    maxFileSizeMb: 'Maximum file size in MB',
    requireFileDescription: 'Require file description',
    imageSource: 'Permitted image source',
    imageSources: { CAMERA: 'Camera', GALLERY: 'Gallery', BOTH: 'Camera and gallery' },
    requireSignerName: 'Require signer name',
    logic: 'Conditional logic',
    addRule: 'Add rule',
    removeRule: 'Remove rule',
    operators: {
      EQUALS: 'equals',
      NOT_EQUALS: 'does not equal',
      CONTAINS: 'contains',
      NOT_CONTAINS: 'does not contain',
      GREATER_THAN: 'greater than',
      LESS_THAN: 'less than',
      EMPTY: 'is empty',
      NOT_EMPTY: 'is not empty',
      ONE_OF: 'one of',
      ALL_OF: 'all of',
      BETWEEN: 'between',
    },
    consentText: 'Consent text',
    consentPurpose: 'Purpose of consent',
    consentSignature: 'Require signature',
    repeatChildren: 'Child questions',
    pageBreak: 'Page break after this section',
    completionSection: 'Completion section',
    consentDocumentVersion: 'Document version',
    consentWithdrawal: 'Withdrawal notice',
    consentName: 'Require confirming person name',
    productFilters: 'Product filters',
    productDisplay: 'Product display and answer fields',
    productFilter: {
      productIds: 'Specific products',
      categoryIds: 'Categories',
      productGroups: 'Product groups',
      tags: 'Tags',
      rootCategoryId: 'Root category',
      searchProducts: 'Search product name or number',
      searchCategories: 'Search categories',
      selectedItem: 'Selected product',
      removeSelected: 'Remove selected product',
      clearProducts: 'Clear product selection',
      allCategories: 'All categories',
      productTypes: 'Product types',
      activeOnly: 'Active products only',
      customerSpecificAssortment: 'Customer-specific assortment',
      availableOnly: 'Available stock only',
      includeSubcategories: 'Include subcategories',
    },
    productTypes: {
      STOCK: 'Stock item',
      NON_STOCK: 'Non-stock item',
      SERVICE: 'Service',
      SET: 'Set',
      DEPOSIT: 'Deposit item',
    },
    productDisplayFields: {
      showImage: 'Product image',
      showName: 'Product name',
      showArticleNumber: 'Product number',
      showDescription: 'Description',
      showPackaging: 'Packaging units',
      showPrice: 'Price',
      showStock: 'Stock',
      showCategories: 'Categories',
      showTags: 'Tags',
      allowQuantity: 'Quantity input',
      allowInterest: 'Interest',
      allowCurrentUse: 'Current use',
      allowPlannedPurchaseDate: 'Planned purchase date',
      allowCompetitorProduct: 'Competing product',
      allowRemark: 'Comment',
      allowComparison: 'Product comparison',
      allowProductPhoto: 'Product photo',
      allowWatchlist: 'Watchlist',
    },
    minRows: 'Minimum entries',
    maxRows: 'Maximum entries',
    addButtonLabel: 'Add-button label',
    ruleIf: 'If',
    ruleOperator: 'Operator',
    ruleValue: 'Comparison value',
    conditionSourceQuestion: 'Condition source question',
    conditionOperator: 'Condition operator',
    ruleAction: 'Then',
    combination: 'Combination',
    settings: 'Template settings',
    welcomeText: 'Welcome text',
    completionText: 'Completion text',
    privacyText: 'Privacy text',
    estimatedMinutes: 'Estimated duration in minutes',
    useTenantLogo: 'Show tenant logo',
    customerMode: 'Allow customer mode',
    allowBackNavigation: 'Allow back navigation',
    fullscreen: 'Offer full screen',
    idleLockMinutes: 'Idle lock in minutes',
    offlineMode: 'Allow offline use',
    allowSensitiveOffline: 'Allow sensitive data offline',
    preloadProductLimit: 'Maximum products to preload',
    progress: 'Progress indicator',
    oneQuestionPerPage: 'One question per page',
    oneSectionPerPage: 'One section per page',
    hiddenAnswerPolicy: 'Handling of hidden answers',
    hiddenPolicies: { DELETE: 'Delete answer', MARK_NOT_APPLICABLE: 'Mark as not applicable' },
    conditions: 'Conditions',
    addCondition: 'Add condition',
    removeCondition: 'Remove condition',
    logicTarget: 'Target',
    combinators: { AND: 'AND', OR: 'OR' },
    logicActions: {
      SHOW: 'Show',
      HIDE: 'Hide',
      SKIP_TO_SECTION: 'Skip to section',
      MARK_NOT_APPLICABLE: 'Mark as not applicable',
    },
    optimisticConflict: 'The template changed in the meantime. Reload the latest version.',
  },
  results: {
    title: 'Questionnaire results',
    subtitle: 'Filter, review and securely export questionnaire runs.',
    detailTitle: 'Result details',
    analytics: 'Analytics',
    search: 'Search results',
    template: 'Template',
    version: 'Version',
    status: 'Status',
    period: 'Period',
    employee: 'Employee',
    partner: 'Partner',
    partnerRole: 'Partner role',
    partnerless: 'Without partner',
    completeness: 'Completeness',
    product: 'Product',
    date: 'Date',
    contact: 'Contact',
    duration: 'Duration',
    durationMinutes: '{{value}} min',
    attachments: 'Files / photos',
    selectedProducts: 'Products',
    syncStatus: 'Synchronisation',
    postprocessStatus: 'Review',
    empty: 'No results match these filters.',
    loadError: 'Results could not be loaded.',
    exportCsv: 'Export list as CSV',
    exportJson: 'Create structured JSON export',
    exportPdf: 'Open PDF report',
    exportSuccess: 'The export was created.',
    exportQueued: 'The export was started as a background job.',
    exportJobTitle: '{{format}} export',
    exportRows: '{{count}} results',
    exportProgress: 'Export job progress',
    exportDownload: 'Download export',
    exportFailed: 'The export failed ({{code}}).',
    exportUnknownError: 'Unknown error',
    exportLoadError: 'Export jobs could not be loaded.',
    exportStatuses: {
      PENDING: 'Queued',
      PROCESSING: 'Processing',
      COMPLETED: 'Ready',
      FAILED: 'Failed',
    },
    answers: 'Answers by section',
    consents: 'Consents',
    audit: 'Audit timeline',
    transfers: 'ERP transfers',
    revisions: 'Revisions',
    syncEvents: 'Synchronisation events',
    distribution: 'Answer distribution',
    average: 'Average',
    trend: 'Trend over time',
    completionRate: 'Completion rate',
    abandonmentRate: 'Abandonment rate',
    averageDuration: 'Average completion time',
    noAnalytics: 'No questions have been enabled for analytics.',
    analyticsError: 'The aggregate analytics could not be loaded.',
    allTemplates: 'All templates',
    allRoles: 'All partner roles',
    allCompleteness: 'Complete and incomplete',
    employeeId: 'Employee ID',
    productId: 'Product ID',
    productCategory: 'Product category',
    categoryId: 'Category ID',
    analyticsKey: 'Analytics key',
    answerOperator: 'Answer operator',
    answerValue: 'Answer value',
    startedCount: 'Started',
    completedCount: 'Completed',
    numericSummary: 'Avg {{average}} · Min {{minimum}} · Max {{maximum}}',
    productInterests: 'Product interests',
    roleDistribution: 'Distribution by partner role',
    startedShort: 'S {{value}}',
    completedShort: 'C {{value}}',
    abandonedShort: 'A {{value}}',
    partnerRoles: {
      CUSTOMER: 'Customer',
      PROSPECT: 'Prospect',
      SUPPLIER: 'Supplier',
      PARTNERLESS: 'Without partner',
    },
    dateFrom: 'From',
    dateTo: 'To',
    revoked: 'Revoked',
    revisionNumber: 'Revision {{number}}',
    createRevision: 'Create correction revision',
    revisionDescription:
      'The correction creates a new traceable revision. The original remains unchanged.',
    revisionReason: 'Reason for correction',
    previewRevision: 'Review correction',
    confirmRevision: 'Create revision',
    revisionCreated: 'The correction revision was created.',
    revisionError: 'The correction revision could not be created.',
    systemActor: 'System',
    targetEntity: 'Target: {{type}} · {{id}}',
    eventStatuses: {
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      SUCCEEDED: 'Succeeded',
      FAILED: 'Failed',
    },
    syncEventTypes: {
      DRAFT_CREATED: 'Local draft created',
      ANSWERS_SAVED: 'Answers synchronised',
      ATTACHMENT_QUEUED: 'File queued',
      ATTACHMENT_UPLOADED: 'File uploaded',
      COMPLETION_REQUESTED: 'Completion requested',
      COMPLETION_CONFIRMED: 'Completion confirmed',
      LOCAL_DATA_CLEARED: 'Local data cleared',
    },
    auditActions: {
      CREATE: 'Created',
      UPDATE: 'Updated',
      DELETE: 'Deleted',
      LOGIN: 'Login',
      LOGOUT: 'Logout',
      EXPORT: 'Exported',
      POST: 'Processed',
      APPROVE: 'Approved',
      CANCEL: 'Cancelled',
      VIEW: 'Viewed',
    },
    postprocess: {
      NOT_REQUIRED: 'Not required',
      REQUIRED: 'Required',
      IN_PROGRESS: 'In progress',
      COMPLETED: 'Completed',
    },
  },
  partnerRecord: {
    title: 'Questionnaires for this business partner',
    subtitle: 'All linked runs with their status, answers, media, and results.',
    empty: 'No questionnaire has been completed for this business partner yet.',
    loadError: 'The linked questionnaires could not be loaded.',
    open: 'Open questionnaire',
  },
  legalHold: {
    title: 'Legal hold',
    statuses: {
      NONE: 'No hold',
      ACTIVE: 'Active',
      EXPIRED: 'Expired',
    },
    noneDescription: 'This questionnaire run is not subject to a legal hold.',
    indefinite: 'Held indefinitely',
    untilValue: 'Held until {{value}}',
    set: 'Set hold',
    change: 'Change hold',
    release: 'Release hold',
    setTitle: 'Set legal hold',
    setDescription:
      'An active hold prevents automatic cleanup and anonymisation of this questionnaire run.',
    reason: 'Reason for the legal hold',
    until: 'Hold until (optional)',
    untilHint: 'Without an end time, the hold remains active indefinitely.',
    untilInvalid: 'The end time must be in the future.',
    confirmSet: 'Set legal hold',
    setSuccess: 'The legal hold was saved.',
    saveError: 'The legal hold could not be saved.',
    releaseTitle: 'Release legal hold',
    releaseDescription:
      'After release, the questionnaire run may again be cleaned up or anonymised according to the retention policy.',
    releaseReason: 'Reason for releasing the hold',
    confirmRelease: 'Release legal hold',
    releaseSuccess: 'The legal hold was released.',
    releaseError: 'The legal hold could not be released.',
    loadError: 'The legal hold could not be loaded.',
  },
  settings: {
    title: 'Questionnaire settings',
    subtitle: 'Tenant-wide rules for retention, customer mode, offline use and reports.',
    loading: 'Loading questionnaire settings.',
    loadError: 'Questionnaire settings could not be loaded.',
    invalid: 'Please review the entered values.',
    saved: 'Questionnaire settings were saved.',
    saveError: 'Questionnaire settings could not be saved.',
    retention: 'Retention and cleanup',
    retentionDays: 'Retention period in days',
    abandonedDraftCleanupDays: 'Clean abandoned drafts after days',
    customerMode: 'Customer mode',
    customerSessionTtlMinutes: 'Maximum session duration in minutes',
    customerIdleLockMinutes: 'Idle lock in minutes',
    offlineAndReports: 'Offline use and reports',
    offlineCatalogMaxProducts: 'Maximum products to preload securely',
    allowSensitiveOffline: 'Allow encrypted offline storage of sensitive answers',
    createPdfOnCompletion: 'Create a PDF report after completion',
    attachPdfToPartner: 'Expose the PDF report in the partner record',
  },
} as const;
